import React, { useState, useEffect } from 'react'
import { StyleSheet, ScrollView, View, Platform, Image, Linking } from 'react-native'
import { Text, Spinner, Button } from '@ui-kitten/components'
import { loginWithEmail } from '../../global/Firebase/firebase'
import StyledTextInput from '../../components/StyledTextInput'
import * as Sentry from "@sentry/react-native"
import HeaderIconButton from '../../components/HeaderIconButton'
import { sendFBAnalyticsEvent } from '../../global/Firebase/firebaseAnalytics'
import { useTranslation } from 'react-i18next'

export default function LoginScreen({ navigation }) {
  const { t } = useTranslation()
  const [loginError, setLoginError] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (Platform.OS === 'web' && navigation.getState()?.index === 0) {
      navigation.setOptions({
        headerLeft: () => (
          <HeaderIconButton
            onPress={() => {
              Linking.openURL('https://atlas-app.org')
            }}
            iconName='home-outline'
          />
        ),
      })
     }
  }, [])

  async function handleOnLogin(values) {
    // const { email, password } = values
    if (email === '') {
      setLoginError(t('login.emailRequired'))
      return
    }
    if (password === '') {
      setLoginError(t('login.passwordRequired'))
      return
    }
    setIsLoading(true)
    try {
      await loginWithEmail(email, password)
      sendFBAnalyticsEvent('Login')
      // setIsLoading(false)
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        setLoginError(t('login.userNotFound'))
      } else if (error.code === 'auth/wrong-password') {
        setLoginError(t('login.wrongPassword'))
      } else if (error.code === 'auth/invalid-email') {
        setLoginError(t('login.invalidEmail'))
      } else if (error.code === 'auth/user-disabled') {
        setLoginError(t('login.userDisabled'))
      } else if (error.code === 'auth/too-many-requests') {
        setLoginError(t('login.tooManyRequests'))
      } else if (error.code === 'auth/network-request-failed') {
        setLoginError(t('login.networkRequestFailed'))
      } else {
        Sentry.captureException(error)
        setLoginError(error.message)
      }
      setIsLoading(false)
    }
  }

  return (
    <ScrollView contentContainerStyle={styles.topContainer}>
      <View style={styles.container}> 
        <Text category='label' style={styles.label}>
          {t('login.email')}
        </Text>
        <StyledTextInput 
          value={email}
          onChangeText={setEmail}
          keyboardType="email-address"
          textContentType="emailAddress"
          autoFocus={true}
          autoCapitalize="none"
          autoCorrect={false}
          style={styles.input}
        />
        <Text category='label' style={styles.label}>
          {t('login.password')}
        </Text>
        <StyledTextInput 
          value={password}
          onChangeText={setPassword}
          secureTextEntry={true}
          textContentType="password"
          autoCapitalize="none"
          autoCorrect={false}
          style={styles.input}
          onSubmitEditing={({nativeEvent}) => {
            handleOnLogin()
          }}
        />
        {loginError != null && (<Text style={styles.submitButton} status='danger'>{loginError}</Text>)}
        {isLoading ? (
            <View style={styles.spinner}><Spinner /></View>
          ) : (
            <Button onPress={handleOnLogin} style={styles.submitButton}>
              {t('login.loginCTA')}
            </Button>
          )
        }   
        <Button appearance='ghost' onPress={() => {navigation.navigate('ForgotPassword')}} style={styles.submitButton}>
          {t('login.passwordReset')}
        </Button>
        <Button appearance='ghost' onPress={() => {navigation.navigate('Funnel')}}>
          {t('login.newOrgSignUp')}
        </Button>
      </View>
      {Platform.OS === 'web' && <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', alignSelf: 'stretch', marginTop: 'auto', marginBottom: 20, marginHorizontal: 20}}>
        <View>
          <Text category='h5' style={styles.title}>ATLAS</Text>
        </View>
        <Image source={require('../../assets/almaty.png')} style={{width: 50, height: 50, resizeMode: 'contain', alignSelf: 'flex-end'}}/>
      </View>}
     
    </ScrollView>
    
  );
}

const styles = StyleSheet.create({
  topContainer: {
    flex: 1, 
    alignItems: 'center',
  },
  container: {
    flex: 1,
    padding: 15,
    width: '90%',
    maxWidth: 800,
    // alignItems: 'center',
    // alignContent: 'center',
  },
  title: {
    marginBottom: 15,
    textAlign: 'center'
  },
  submitButton: {
    marginTop: 15,
  },
  spinner: {
    marginTop: 15,
    alignItems: 'center'
  },
  label: {
    marginTop: 10,
    marginBottom: 5,
  },
});
